<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          mb-4 :class="{'px-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex lg6>
                        <h1 class="section-title-main my-3 mr-4 font-weight-regular">{{ $t("Банк идей") }}</h1>
                    </v-flex>
                    <v-flex lg6>
                        <inputIcon v-model="ideas_search" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>
                </v-layout>
                <v-layout wrap align-center justify-space-between
                          :class="{'px-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex lg6 md5 xs12
                            :class="{'pr-0 mb-4': $vuetify.breakpoint.smAndDown,'pr-5' : $vuetify.breakpoint.mdAndUp}"
                    >
                        <v-select
                            v-model="theme"
                            :items="themes"
                            solo
                            append-icon=""
                            :label="$t('Все темы')"
                            class="input"
                            @change="CLEAR_PAGES()"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex xl4 lg3 md4
                            xs12 :class="{'mb-4': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <v-select
                            :items="[
                              {
                                text: $t('Сначала новые'),
                                value: 'Сначала новые',
                              },
                              {
                                text: $t('Сначала старые'),
                                value: 'Сначала старые',
                              },
                            ]"
                            solo
                            append-icon=""
                            :label="$t('Сначала новые')"
                            class="input"
                            @change="sorting_by_date($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex xl2 lg3 md3
                            text-md-right text-sm-left :class="{'pl-0': $vuetify.breakpoint.smAndDown,'pl-4' : $vuetify.breakpoint.mdAndUp}"
                    >
                        <buttonRed @click.native="OPEN_MODAL('ideas_bank_modal')">{{ $t("Предложить идею") }}</buttonRed>
                    </v-flex>
                </v-layout>
                <v-layout my-5 column>
                    <div v-for="(idea, i) in paginated" :key="i">
                        <ideaBlock class="mb-4" :content="idea"
                                   :class="{'background-light': !(i%2)}"
                        />
                    </div>
                </v-layout>
                <v-layout v-if="ideas.length > 10" mb-5 justify-space-between
                          align-center
                          wrap :class="{'px-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex md3 sm5 xs12
                            mb-4 text-sm-left text-xs-center
                    >
                        <buttonRed :class="{'mr-5': $vuetify.breakpoint.smAndUp}" @click.native="OPEN_MODAL('ideas_bank_modal')">{{ $t("Предложить идею") }}</buttonRed>
                    </v-flex>
                    <v-flex md5 sm7 xs12
                            mb-4
                    >
                        <div class="text-xs-center">
                            <v-pagination
                                v-model="page"
                                :length="Math.ceil(filtered_by_theme.length / selected_number)"
                                :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                                prev-icon="arrow_back_ios"
                                next-icon="arrow_forward_ios"
                            />
                        </div>
                    </v-flex>
                    <v-flex md4 sm6 mb-4>
                        <v-select
                            :items="$vuetify.breakpoint.mdAndUp ? [
                              {
                                text: $t('Показывать по 10'),
                                value: 'Показывать по 10',
                              },
                              {
                                text: $t('Показывать по 25'),
                                value: 'Показывать по 25',
                              },
                              {
                                text: $t('Показывать по 50'),
                                value: 'Показывать по 50',
                              },
                              {
                                text: $t('Показывать по 100'),
                                value: 'Показывать по 100',
                              },
                            ]
                            :
                            [
                              {
                                text: $t('Показывать по 10'),
                                value: 'Показывать по 10',
                              },
                              {
                                text: $t('Показывать по 25'),
                                value: 'Показывать по 25',
                              },
                              {
                                text: $t('Показывать по 50'),
                                value: 'Показывать по 50',
                              },
                            ]"
                            solo
                            append-icon=""
                            :label="$t('Показывать по 10')"
                            class="input"
                            @change="show_number($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-dialog :value="ideas_bank_modal" persistent content-class="scrolled-dialog">
                <ideaModal v-if="ideas_bank_modal" />
            </v-dialog>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import buttonRed   from '@/components/ui/buttons/button_red';
import ideaModal from './Ideas_bank_modals/Ideas_bank_modal';
import ideaBlock from './Idea_block';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    ideaModal,
    ideaBlock,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapGetters('ideas_bank', [
      'ideas_bank_modal',
      'ideas',
      'themes',
      'selected_page',
      'selected_theme',
      'selected_number',
      'filtered_by_theme',
      'paginated',
    ]),
    ...mapGetters('ideas_bank/breadcrumbs', [
      'breadcrumbs',
    ]),
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    ideas_search: {
      get() {
        return this.search;
      },
      set($event) {
        return this.SEARCH_STRING($event.target.value);
      },
    },
  },
  mounted() {
    this.get_ideas();
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_SELECTED_THEME',
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SORT_BY_DATE',
      'SEARCH_STRING',
    ]),
    ...mapActions('ideas_bank', [
      'show_number',
      'sorting_by_date',
      'get_ideas',
    ]),
  },
};
</script>
